import React, {PropTypes} from 'react';

export default function RecentlyViewed() {
  return (
    <div className="recently-viewed">
      <div className="title">RECENTLY VIEWED</div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/features/dashboard/components/RecentlyViewed.js